var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDollarSmall(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26.238,
    height: 34.839,
    viewBox: "0 0 26.238 34.839",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n            .cls-1{fill:none;stroke:#fff;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;stroke-width:2px}\n        "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    "data-name": "Group 8",
    transform: "translate(1 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shape",
    d: "M0 31.573a1.278 1.278 0 0 0 1.282 1.265h21.674a1.278 1.278 0 0 0 1.282-1.265L24.174 6.96 17.121 0H1.282A1.278 1.278 0 0 0 0 1.265z",
    className: "cls-1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-2",
    d: "M0 0v5.579a1.475 1.475 0 0 0 1.458 1.458h5.579",
    className: "cls-1",
    transform: "translate(16.419)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-3",
    d: "M0 9.088a3.124 3.124 0 0 0 3.128 3.029 3.082 3.082 0 0 0 3.127-3.029A3.124 3.124 0 0 0 3.128 6.06 3.082 3.082 0 0 1 0 3.031 3.124 3.124 0 0 1 3.128 0a3.082 3.082 0 0 1 3.127 3.031",
    className: "cls-1",
    transform: "translate(8.992 10.164)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-5",
    d: "M1 0v1.955",
    className: "cls-1",
    transform: "translate(11.51 8.21)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Shape-4",
    d: "M1 0v1.955",
    className: "cls-1",
    transform: "translate(11.51 22.283)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDollarSmall);
export default __webpack_public_path__ + "static/media/icon-dollar-small.bf76e0430530b372f32657e97ee8a34f.svg";
export { ForwardRef as ReactComponent };